<script>
import { computed, onMounted, ref, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useSeoMeta } from '@unhead/vue';
import { createRequest } from "../../../../api/preOrders";
import { useRouter } from "vue-router";
import { useState, useToaster, useLog } from "../../../../services/hooks";
import { megabytesToBytes } from "../../../../helpers/file";
import { getDateInSeconds } from "../../../../helpers/dateHelper";
import { BREADCRUMBS_SET_ITEM, CART_CLEAR, CART_GET_CART_DEFAULT } from "../../../../store/constants";
import LayoutLegacyComponent from "../../../../layouts/LayoutLegacy";
import BreadcrumbComponent from "../../../../components/BreadcrumbComponent";
import FilesComponent from "./steps/files/FilesComponent.vue";
import NotarialCaseComponent from "./steps/notarialCase/NotarialCaseComponent.vue";
import LoaderComponent from "../../../../components/LoaderComponent.vue";
import ModalComponent from "../../../../components/ModalComponent.vue";
import ModalChoiceNotifyComponent from "./modal/ModalChoiceNotifyComponent.vue";
import ModalInfoComponent from "./modal/ModalInfoComponent.vue";
import ClientNameComponent from "@/views/cart/views/order/steps/clientName/ClientNameComponent.vue";

export default {
    name: "CartNotaryView",
    components: {
      LayoutLegacyComponent,
      BreadcrumbComponent,
      FilesComponent,
      NotarialCaseComponent,
      LoaderComponent,
      ModalComponent,
      ModalChoiceNotifyComponent,
      ModalInfoComponent,
      ClientNameComponent
    },
    setup() {

      const store = useStore();
      const router = useRouter();
      const { alertError } = useToaster();
      const allowedUploadFileExtensions = ['jpg','jpeg','png','heic','pdf','heif'];
      const allowedMaxSumSizeUploadFiles = megabytesToBytes(10);
      const storeCartObjects = computed(() => store.getters[CART_GET_CART_DEFAULT].items);
      const reportType = computed(() => store.getters[CART_GET_CART_DEFAULT].type);
      const { recordLog } = useLog();

      const [objects, setObjects] = useState([]);
      const [testator] = useState({
        name: { value:'', hasError: false, errorText: '' },
        dateDeath: { value:'', hasError: false, errorText: '' }
      });
      const [clientName] = useState({
        value:'', hasError: false, errorText: ''
      });
      const [notary, setNotary, clearNotary] = useState({ name: null, region: null });
      const [notarialCaseNumber, setNotarialCaseNumber] = useState('');
      const [notarialCaseDateDeath, setNotarialCaseDateDeath] = useState(null);
      const [localNotaryId, setLocalNotaryId] = useState(null);
      const [logNotarialCase, setLogNotarialCase] = useState([]);

      const [currentStep, setCurrentStep] = useState(1);
      const [isFoundNotarialCase, setIsFoundNotarialCase] = useState(false);
      const [hasTryFoundNotarialCase, setHasTryFoundNotarialCase] = useState(false);
      const [isShowLoader, setIsShowLoader] = useState(false);
      const [loaderText, setLoaderText] = useState(null);
      const [notarialCases, setNotarialCases] = useState([]);
      const [smsNotifyType] = useState(1);
      const [showModalChoiceNotify, setShowModalChoiceNotify] = useState(false);
      const [showModalInfo, setShowModalInfo] = useState(false);
      const [isDataServiceUnavailable, setIsDataServiceUnavailable] = useState(false);
      const [isRequestedCreateSubmit, setIsRequestedCreateSubmit] = useState(false);

      const initObjects = () => {
        const objects = storeCartObjects.value.map(item => {
          const object = store.getters.findObjectById(item.id);
          return {
            ...object,
            files: [],
            filesInfo: [],
            filesError: ''
          };
        });
        setObjects(objects);
      };

      const getNormalizedTestatorDate = (value) => {
        const date = new Date(value);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
      };

      const createFinalLogRow = async () => {

        const testatorName = testator.value.name.value;
        const testatorDate = testator.value.dateDeath.value;
        const caseNumber = notarialCaseNumber.value;

        if (testatorName && testatorDate) {

          let logText = [];

          logText.push(testatorName + ' ' + getNormalizedTestatorDate(testatorDate));
          logText.push(caseNumber);

          await recordLog('Заполнено ФИО умершего + дата смерти (' + logText.join(', ') + ')');
        }

        return true;
      }

      const nextStepHandler = (e) => {
        e.preventDefault();
        if (currentStep.value === 2) {
          if (!isFoundNotarialCase.value && !localNotaryId.value && !notarialCaseNumber.value) {
            recordLog('Заказчик на стал указывать нотариуса');
          }
        }
        setCurrentStep(currentStep.value+1);
      };

      const prevStepHandler = (e) => {
        e.preventDefault();
        setCurrentStep(currentStep.value-1);
      };

      const clearSearchNotarialStep = () => {
        setNotarialCases([]);
        clearNotary();
        setLocalNotaryId(null);
        setNotarialCaseNumber('');
        setNotarialCaseDateDeath(null);
        setIsFoundNotarialCase(false);
        setHasTryFoundNotarialCase(false);
        setLogNotarialCase([]);
      };

      const loader = (show, text = null) => {
        setLoaderText(text);
        setIsShowLoader(show);
      };

      const isShowedModals = () => {
        if(!store.state.auth.user.hasOrder) {
          if (store.state.auth.user.hasWhatsApp && !showModalChoiceNotify.value) {
            setShowModalChoiceNotify(true);
            return true;
          }
          if(!showModalInfo.value) {
            setShowModalInfo(true);
            return true;
          }
        }
        return false;
      };

      const getFormData = () => {

        const formData = new FormData();

        for (let objectIndex=0; objectIndex < objects.value.length; objectIndex++) {
          const object = objects.value[objectIndex];
          for (let fileIndex=0; fileIndex < object.files.length; fileIndex++) {
            const file = object.files[fileIndex];
            const fileInfo = object.filesInfo[fileIndex];
            formData.append('files[' + objectIndex + '][' + fileIndex + ']', file.data, file.name);
            formData.append('prevFilesInfo[name][' + objectIndex + '][' + fileIndex + ']', fileInfo.name);
            formData.append('prevFilesInfo[size][' + objectIndex + '][' + fileIndex + ']', fileInfo.size);
            formData.append('prevFilesInfo[width][' + objectIndex + '][' + fileIndex + ']', fileInfo.width);
            formData.append('prevFilesInfo[height][' + objectIndex + '][' + fileIndex + ']', fileInfo.height);
          }
          formData.append('objects[' + objectIndex + ']', object.id);
        }

        if (!isFoundNotarialCase.value) {
          notarialCaseDateDeath.value = getDateInSeconds(testator.value.dateDeath.value);
        }

        formData.append('testator[name]', testator.value.name.value);
        formData.append('testator[date]', notarialCaseDateDeath.value);

        formData.append('notarialCase[isFoundedInService]', Number(isFoundNotarialCase.value));
        formData.append('notarialCase[notaryName]', notary.value.name);
        formData.append('notarialCase[notaryRegion]', notary.value.region);
        formData.append('notarialCase[caseNumber]', notarialCaseNumber.value);
        formData.append('notarialCase[isServiceUnavailable]', Number(isDataServiceUnavailable.value));

        if (localNotaryId.value) {
          formData.append('notarialCase[localNotaryId]', localNotaryId.value);
        }

        for (let i = 0; i < logNotarialCase.value.length; i++) {
          formData.append('notarialCase[logBySearchNumberInService][]', logNotarialCase.value[i]);
        }

        formData.append('clientName', clientName.value.value);

        formData.append('reportType', reportType.value);
        formData.append('smsNotifyType', smsNotifyType.value);

        return formData;
      };

      const createSubmitPreOrderHandler = async (e) => {

        e.preventDefault();

        if (isRequestedCreateSubmit.value) {
          return;
        }

        if (isShowedModals()) {
          return;
        }

        await createFinalLogRow();

        setIsRequestedCreateSubmit(true);
        loader(true);

        recordLog('Создание и отправка заказа на проверку');

        createRequest(getFormData())
          .then(() => {
            store.dispatch(CART_CLEAR);
            loader(false);
            router.push('/orders');
          })
          .catch(err => {
            console.log(err);
            loader(false);
            alertError('Error!');
          });
      };

      watchEffect(initObjects);

      onMounted(() => {
        store.commit(BREADCRUMBS_SET_ITEM, {
          item: { name: 'Корзина товаров', path: '/cart' }
        });
        store.commit(BREADCRUMBS_SET_ITEM, {
          item: { name: 'Оформление', path: '/cart/notary' }
        });
        useSeoMeta({ title: 'Оформление', keywords: '', description: '' });
      });

      return {
        currentStep,
        objects,
        allowedUploadFileExtensions,
        allowedMaxSumSizeUploadFiles,
        nextStepHandler,
        prevStepHandler,
        testator,
        notarialCases,
        setNotarialCases,
        hasTryFoundNotarialCase,
        setHasTryFoundNotarialCase,
        setIsFoundNotarialCase,
        clearSearchNotarialStep,
        isShowLoader,
        loaderText,
        loader,
        setLogNotarialCase,
        setNotary,
        setNotarialCaseNumber,
        setNotarialCaseDateDeath,
        notarialCaseNumber,
        notary,
        createSubmitPreOrderHandler,
        smsNotifyType,
        showModalChoiceNotify,
        showModalInfo,
        clearNotary,
        setLocalNotaryId,
        isDataServiceUnavailable,
        setIsDataServiceUnavailable,
        clientName
      }
    }
}
</script>

<template>
  <layout-legacy-component>
    <breadcrumb-component/>
    <div>
      <files-component
        v-if="currentStep === 1"
        :objects="objects"
        :allowed-extensions="allowedUploadFileExtensions"
        :allowed-max-sum-upload-size="allowedMaxSumSizeUploadFiles"
        :next-step-handle="nextStepHandler"
      />
      <notarial-case-component
        v-else-if="currentStep === 2"
        :testator="testator"
        :next-step-handler="nextStepHandler"
        :prev-step-handler="prevStepHandler"
        :notarial-cases="notarialCases"
        :set-notarial-cases="setNotarialCases"
        :has-try-found-notarial-case="hasTryFoundNotarialCase"
        :set-has-try-found-notarial-case="setHasTryFoundNotarialCase"
        :set-is-found-notarial-case="setIsFoundNotarialCase"
        :clear-search-notarial-step="clearSearchNotarialStep"
        :loader="loader"
        :set-log-notarial-case="setLogNotarialCase"
        :set-notary="setNotary"
        :clear-notary="clearNotary"
        :set-notarial-case-number="setNotarialCaseNumber"
        :notarial-case-number="notarialCaseNumber"
        :notary="notary"
        :set-local-notary-id="setLocalNotaryId"
        :is-data-service-unavailable="isDataServiceUnavailable"
        :set-is-data-service-unavailable="setIsDataServiceUnavailable"
        :set-notarial-case-date-death="setNotarialCaseDateDeath"
      />
      <client-name-component
        v-else-if="currentStep === 3"
        :client-name="clientName"
        :create-pre-order-submit-handler="createSubmitPreOrderHandler"
        :prev-step-handler="prevStepHandler"
      />
      <modal-choice-notify-component
        :show="showModalChoiceNotify"
        v-model:value="smsNotifyType"
        :create-submit-pre-order-handler="createSubmitPreOrderHandler"
      />
      <modal-info-component
        :show="showModalInfo"
        :create-submit-pre-order-handler="createSubmitPreOrderHandler"
      />
      <loader-component v-if="isShowLoader" :text="loaderText" />
    </div>
  </layout-legacy-component>
</template>

<style scoped>

.send-to-choice h2 {
  text-align: center;
}

.send-to-choice .form-group {
  display: inline-block;
  text-align: center;
  width: 50%;
  vertical-align: middle;
}

.send-to-choice .form-group label {
  margin-left: 10px;
}

.notify-content li {
  padding: 10px 0;
  font-size: 17px;
  line-height: 24px;
}

.notify-content button {
  background-color: #3194ca;
  border: none;
}

</style>
